import React, { Component } from 'react'
import { withRouter } from 'react-router'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import AlertRuleCreatePageUI from './AlertRuleCreatePageUI.js'

class AlertRuleCreatePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      project: null,
      messageList: null,
    }
  }

  render() {
    return (
      <AlertRuleCreatePageUI
        context={this.props.context}
        project={this.state.project}
        messageList={this.state.messageList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProjects(context)
    this.getMessages(context)
  }

  getProjects(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/projects`,
      cacheKey: CacheKeys.Projects(context.session.accountId, context.session.userId),
      callback: this.getProjectsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectsCallback = (response) => {
    if (response.errorList.length > 0) {
      this.props.history.replace('/projects')
      return
    }
    console.log('---------', response.projectList);
    let projectsFiltered = response.projectList.filter(project => project.projectId === this.props.match.params.projectId)
    if (projectsFiltered.length === 1) {
      this.setState({project : projectsFiltered[0]})
    }
    else {
      let context = this.props.context
      CacheManager.removeObject(CacheKeys.Projects(context.session.accountId, context.session.userId))
      this.props.history.replace('/projects')
    }
  }

  getMessages(context) {
    let arr = [
      'c_alert_rule',
      'c_task_priority',
      'c_task_due_in',
      'c_task_due_past',
      'c_repeat',
      'c_save',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_alrt_crt', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(AlertRuleCreatePageSF)
